import React, { useCallback } from 'react'
import { isEmpty } from 'lodash'
import { DraggingItemContext } from '../DraggingItemProvider'
import { DRAGNDROP_TYPE } from '../../../enums'
import { useCanAddItemToTimeline } from '../../../hooks/useCanAddItemToTimeline'

export const useLayerCanDropItem = () => {
  const canAddItemToTimeline = useCanAddItemToTimeline()
  const { resetProps } = React.useContext(DraggingItemContext)

  return useCallback((item, acceptedTypes) => {
    const { incompatibleFileExtensions } = item
    const incompatibleExtensions = !isEmpty(incompatibleFileExtensions)
      ? Object.values(incompatibleFileExtensions)
        .reduce((result, item) => {
          result.push(...item)
          return result
        }, [])
      : []

    const assets = []

    if (DRAGNDROP_TYPE.GROUP === item.type && item.selectedItems.length) {
      assets.push(...item.selectedItems.map(item => item.asset))
    } else if (item.asset) {
      assets.push(item.asset)
    }

    const { allValid } = canAddItemToTimeline(incompatibleExtensions, assets)

    if (!allValid) {
      resetProps()
      return false
    }

    if (!acceptedTypes.includes(item?.type)) {
      resetProps()
      return false
    }

    return true
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ canAddItemToTimeline ])
}
